import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface PushCbcDataToEfileResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class PushCbcDataToEfileService {
  constructor(private http: HttpClient) {}

  pushDataToEfile(
    baseUrl: string,
    ssoId: string
  ): Observable<PushCbcDataToEfileResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=zwibx4`;
    let params = new HttpParams();
    if (ssoId) {
      params = params.set('sso_id', ssoId);
    }

    return this.http.post<PushCbcDataToEfileResponse>(url, params.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
